module.exports = __webpack_public_path__ + "img/the_behavior_change_wheel.7b489154.jpg";